import CardsViewContainer from "../../../../Components/Miscellaneous/JobSearch/CradsView/CardsViewContainer";

const CardsView = () => {
  return <CardsViewContainer />;
};

export default CardsView;
